import Vue from 'vue';
import { MutationTree } from 'vuex';

import { State } from '@/manager/billing/store/state';
import { Note } from '@/manager/convocation/note.model';
import Bill from '@/manager/billing/models/bill.model';


export interface Mutations {
    setBillList: {list: Bill[]};
}

export const mutations: MutationTree<State> = {
    setBillList: (state, payload) => {
        state.list = payload;
    },
    newBill: (state, payload) => {
        state.list.push(payload);
    },
    updateBill: (state, payload) => {
        const index = state.list.map( (item: any) => item.id ).indexOf( payload.id );
        if (index > -1) {
            const bill = state.list[ index ];
            const newBill = Object.assign({}, bill, payload);
            Vue.set( state.list, index, newBill );
        } else {
            state.list.push(payload);
        }
    },
    setBillNotes: (state, payload) => {
        const billNoteListIds = state.billNoteList.map( (item: any) => item.id );
        payload.notes.forEach((note: Note) => {
            const newNote = Object.assign({}, note, { ['billId']: payload.billId });
            const index = billNoteListIds.indexOf( note.id );
            if (index > -1) {
                state.billNoteList.splice( index, 1, newNote );
            } else {
                state.billNoteList.push( newNote );
            }
        });
    },
    newBillNote: (state, payload) => {
        state.billNoteList.push(payload);
    },
    updateBillNote: (state, payload) => {
        const index = state.billNoteList.map( (item: any) => item.id ).indexOf( payload.id );
        if (index > -1) {
            const note = state.billNoteList[ index ];
            const newNote = Object.assign({}, note, payload);
            state.billNoteList.splice( index, 1, newNote );
        }
    },
    removeBillNote: (state, noteId) => {
        const index = state.billNoteList.map( (item: any) => item.id ).indexOf( noteId );
        if (index > -1) {
            state.billNoteList.splice(index, 1);
        }
    },
    setCurrentBill: (state, payload) => {
        state.currentBill = payload;
    },
};
